module.exports = __webpack_public_path__ + "img/welcome-to-ditto-4.da808f82.gif";